// extracted by mini-css-extract-plugin
module.exports = {"AutoSizeTextArea":"AutoSizeTextArea_AutoSizeTextArea__1H59v","CommentSizeTextArea":"AutoSizeTextArea_CommentSizeTextArea__2IwXr"};